function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.898 5.016a.764.764 0 01-.63-.491L8.688.498a.741.741 0 00-1.4 0L5.721 4.525a.747.747 0 01-.63.491l-4.407.439c-.657.066-.922.93-.43 1.395l3.32 3.07c.215.2.304.491.24.784l-.997 4.305c-.151.678.543 1.236 1.124.877l3.674-2.272a.732.732 0 01.77 0l3.674 2.272c.58.359 1.275-.186 1.124-.877l-.985-4.305a.82.82 0 01.24-.784l3.32-3.07c.48-.465.202-1.329-.454-1.395l-4.406-.439z",
  fill: "#747474",
  fillRule: "evenodd"
});

function SvgReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _ref);
}

export default SvgReview;